/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import Container from '@mui/material/Container';
import PageSubHeader from '../Layout/PageSubHeader'


const PrivacyPolicy = ( ) => {

  const { classes } = useStyles();
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <PageSubHeader location={t('titles:privacypolicy')} />
      <Grid container spacing={4} className={classes.pageContainer}>
        <Grid item xs={12} sm={12} md={12}>


          <Container maxWidth="md" component="main">
            <Container maxWidth="sm">
              <Typography style={{ color: "#383e56", textTransform: "uppercase" }} component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                Belltane PRIVACY POLICY
              </Typography>
              <div className={classes.sectionTitleBorder}></div>



            </Container>
          </Container>
          <Container className={classes.cardGrid} maxWidth="md">
            <Grid container maxwidth="sm" justify="center" className={classes.pageContainer} spacing={5} alignItems="stretch" >

              <Grid item xs={12} sm={12} md={12}>
                <Typography variant="h3" className={classes.title}>Privacy</Typography>
                <Typography variant="h5" className={classes.title}>
                  Belltane, LLC operates <a href="https://www.belltane.com">www.belltane.com</a>. This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.
                </Typography>
                <Typography variant="h3" className={classes.title}> Information Collection and Use</Typography>
                <Typography variant="h5" className={classes.title}>
                  While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("Personal Information"). We may use this information, individually or in the aggregate, for technical administration of our Web site(s); research and development; customer and account administration; and to help us focus our marketing efforts more precisely.
                </Typography>
                <Typography variant="h3" className={classes.title}> Log Data</Typography>
                <Typography variant="h5" className={classes.title}>
                  Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data"). This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics. In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this and other usage data.
                </Typography>
                <Typography variant="h3" className={classes.title}> Communications</Typography>
                <Typography variant="h5" className={classes.title}>
                  We may use any Personal Information you provide to contact you with newsletters, marketing or promotional materials and other information that we believe you may find useful
                </Typography>
                <Typography variant="h3" className={classes.title}> Cookies</Typography>
                <Typography variant="h5" className={classes.title}>
                  Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive. Belltane does NOT use "cookies" to collect information. However embedded content, YouTube, WordPress, etc., MAY use cookies. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site. Belltane does use Google Analytics, which may utilize cookies. (See Google Analytics below).
                </Typography>
                <Typography variant="h3" className={classes.title}> Google Analytics
                </Typography>
                <Typography variant="h5" className={classes.title}>
                  Belltane uses Google Analytics and Advertising. We may use any or all of the following:
                  <ul>
                    <li>Remarketing with Google Analytics</li>
                    <li> Google Display Network Impression Reporting</li>
                    <li> Google Analytics Demographics and Interest Reporting</li>
                    <li>Integrated services that require Google Analytics to collect data via advertising cookies and anonymous identifiers</li>
                  </ul>
                </Typography>
                <Typography variant="h3" className={classes.title}>How we use Google Analytics
                </Typography>
                <Typography variant="h5" className={classes.title}>
                <ul>

                <li> We may use remarketing or similar audiences to advertise online.</li>
                <li> Third-party vendors, including Google, may show our ads on sites across the Internet.</li>
                <li> Google uses cookies to serve ads based on someone's past visits to your website.</li>
                <li> We do not run interest-based advertising campaigns that collect personally identifiable information (PII) including, but not limited to, email addresses, telephone numbers, and credit card numbers.</li>
                <li> We do not use or associate personally identifiable information with remarketing lists, cookies, data feeds, or other anonymous identifiers.</li>
                <li> We do not use or associate targeting information, such as demographics or location, with any personally identifiable information collected from the ad or its landing page.</li>
                <li> We do not share any personally identifiable information with Google through our remarketing tag or any product data feeds which might be associated with our ads.</li>
                <li> We do not send Google precise location information without obtaining people's consent.</li>
                <li> If we use a remarketing list, we do not use any sensitive information about our site or app visitors, whether collected directly or associated with a visitor, based on the visitor's profile or behavior on our site or app.</li>
                <li> Google may include in-ads notice labels to disclose interest-based advertising to our users</li>
                <li> Google reserves the right to display to users which remarketing lists they're on, along with the corresponding domain name.</li>
                <li> We do not modify or obscure these notices.</li>
                  </ul>

                </Typography>
                <Typography variant="h3" className={classes.title}>

                  Google Analytics Tracking Opt Out
                </Typography>
                <Typography variant="h5" className={classes.title}>

                  Opt Out of Interest-Based Advertising

                  NAI members are committed to transparency and choice. The NAI opt-out tool was developed in conjunction with our members and the DAA for the express purpose of allowing consumers to "opt out" of the Interest-Based Advertising delivered by our members on Web pages using cookies.

                  NAI Opt Out

                </Typography>
                <Typography variant="h3" className={classes.title}>
                  Security
                </Typography>
                <Typography variant="h5" className={classes.title}>
                  The security of your Personal Information is important to us, but you should remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.

                </Typography>
                <Typography variant="h3" className={classes.title}>
                  Notice to European Union Users

                </Typography>
                <Typography variant="h5" className={classes.title}>
                  Belltane's operations are located primarily in the United States. If you provide information to us, the information will be transferred out of the European Union (EU) to the United States. By providing personal information to us, you are consenting to its storage and use as described herein.

                </Typography>
                <Typography variant="h5" className={classes.title}>
                  This Privacy Policy is effective as of March 20, 2016, and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page. We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.

                </Typography>
                <Typography variant="h3" className={classes.title}>
                  Contact Us

                </Typography>
                <Typography variant="h5" className={classes.title}>
                  If you have any questions about this Privacy Policy, please contact us.
                </Typography>

              </Grid>




            </Grid>

          </Container>
        </Grid>
      </Grid>




    </React.Fragment >
  );
}
const useStyles = makeStyles({ "name": { PrivacyPolicy } })((theme) => ({

  pageContainer: {
    backgroundColor: '#dce7eb',
    padding: '1.5%',

  },

  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },



  sectionTitleBorder: {
    width: '100px',
    height: '2px',
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundColor: '#fb743e',
    marginBottom: '30px',

  },

 
  title: {
    paddingTop:'20px'
  }
}));
export default PrivacyPolicy;
